import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import NavigationLink from '../NavigationLink';

const NavigationNestedLinks = ({ page, selectedSlug }) => (
  <ul className="navigation__list">
    {
      page && Array.isArray(page.pages) && page.pages.map(({
        slug,
        name,
        pages,
        url,
        openInNewWindow,
        additionalClass,
        additionalId,
      }) => (
        <li
          key={slug}
          className="navigation__list-item--vertical"
        >
          <NavigationLink
            extraClass="navigation__link navigation__link--nested"
            textExtraId={additionalId}
            textExtraClass={
              classNames(
                'navigation__link-text navigation__link-text--nested',
                additionalClass,
              )
            }
            name={name}
            pages={pages}
            url={url}
            openInNewWindow={openInNewWindow}
            selected={slug === selectedSlug}
          />
        </li>
      ))
    }
  </ul>
);

NavigationNestedLinks.propTypes = {
  page: PropTypes.shape({
    pages: PropTypes.arrayOf(PropTypes.shape({
      slug: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      url: PropTypes.string,
      pages: PropTypes.array,
      openInNewWindow: PropTypes.bool,
      additionalClass: PropTypes.string,
      additionalId: PropTypes.string,
    })),
  }),
  selectedSlug: PropTypes.string,
};

export default NavigationNestedLinks;
